import { all } from 'redux-saga/effects'

import { companyBannerSaga } from './company-banner/sagas'

export function* employerSaga() {
  yield all([companyBannerSaga()])
}
